import dashboard from './dashboard'
import others from './others'

// Array of sections
export default [...dashboard, ...others]
